import { computed, Signal } from '@angular/core';

export function passwordCriteria(
  password: Signal<string>,
  minChar: number,
  maxChar: number
) {
  return {
    lengthCheck: computed(
      () => password().length >= minChar && password().length <= maxChar
    ),
    uppercase: computed(() => /[A-Z]/.test(password())),
    lowercase: computed(() => /[a-z]/.test(password())),
    number: computed(() => /[0-9]/.test(password())),
    specialChar: computed(() => /[!@#$%^&*(),.?":{}|<>]/.test(password())),
  };
}
